import { ROLES } from '../features/performance/api/UserRoleContext';
import { useAuth } from '../features/auth/AuthContext';

const roleRanks = {
  R3lFolCMdoi: 0,  // Organisation Admin
  nLSSLch316I: 1,   //Chief executive Director
  adeqQmxfCLF: 2,   // Head of the department
  gtMJNK0QVL7: 3,   // Top Staff
  vdVjNaqxblC: 4,   // Senior Staff
  Guest: 99,
};


export function canView(userRole, targetRole) {
  if (!userRole) return false;
  if (userRole === ROLES.ADMIN) return targetRole !== 'Guest';
  if (userRole === 'Guest') return userRole === targetRole;

  const userRank = roleRanks[userRole];
  const targetRank = roleRanks[targetRole];
  
  if (userRank === undefined || targetRank === undefined) {
    console.warn('Undefined role rank:', { userRole, targetRole });
    return false;
  }

  if (userRole === ROLES.CEO) return targetRole !== 'Guest';
  
  return (
    userRank === targetRank ||
    targetRank === userRank + 1 || 
    targetRank === userRank - 1
  );
}

export function canEdit(userRole, targetRole) {
  if (!userRole) return false;
  return userRole === targetRole || userRole === ROLES.ADMIN;
}

export function canDelete(userRole, targetRole) {
  if (!userRole) return false;
  return userRole === targetRole || userRole === ROLES.ADMIN;
}

export const usePermissions = () => {
  const { user } = useAuth();
  const userRole = user?.role;
  
  return {
    canView: (targetRole) => canView(userRole, targetRole),
    canEdit: (targetRole) => canEdit(userRole, targetRole),
    canDelete: (targetRole) => canDelete(userRole, targetRole),
    canEditLevel: (levelId) => canEdit(userRole, levelId),
    canDeleteLevel: (levelId) => canDelete(userRole, levelId)
  };
};
